export interface Portfolio {
  portfolio_name: string;
  base_currency: string;
  report_currency: string;
  portfolioid: string;
  ptype: string;
}
